module.exports = __webpack_public_path__ + "img/Group791.1352abee.png";